import { useTransition } from "react";
import { useTranslations } from "@/lib/useTranslations";
import { useNavigate } from "react-router-dom";

import { createPlaceAction } from "@/api/places-library";
import { Button } from "@/components/ui/Button";

function CreateSpinner() {
  return (
    <span
      aria-hidden
      className="inline-block size-3.5 animate-spin rounded-full border-2 border-zinc-900 border-r-transparent"
    />
  );
}

export function PlacesLibraryCreateButton() {
  const navigate = useNavigate();
  const t = useTranslations("places.library");
  const [isPending, startTransition] = useTransition();

  function handleCreate() {
    startTransition(async () => {
      try {
        const result = await createPlaceAction();
        navigate(result.redirectTo);
      } catch (error) {
        console.error(error);
      }
    });
  }

  return (
    <Button
      type="button"
      disabled={isPending}
      aria-busy={isPending}
      onClick={handleCreate}
      className="inline-flex shrink-0 items-center justify-center gap-2"
    >
      {isPending ? <CreateSpinner /> : null}
      {isPending ? t("creating") : t("createPlace")}
    </Button>
  );
}
